// extracted by mini-css-extract-plugin
export default {"main_cnd":"gencert_main_cnd__TsEsL"};